
// This file is auto-generated. Do not edit directly.
// It combines all translations into a single file.

export const translations = {
        en: {
            ...require('/opt/app/hat/assets/js/apps/Iaso/domains/app/translations/en.json'),
            ...require('/opt/app/node_modules/bluesquare-components/dist/locale/en.json'),
            ...require('/opt/app/plugins/polio/js/src/constants/translations/en.json'),
            ...require('/opt/app/plugins/registry/js/src/constants/translations/en.json'),
        },
    es: {
            ...require('/opt/app/hat/assets/js/apps/Iaso/domains/app/translations/es.json'),
            ...require('/opt/app/node_modules/bluesquare-components/dist/locale/en.json'),
            ...require('/opt/app/plugins/polio/js/src/constants/translations/en.json'),
            ...require('/opt/app/plugins/registry/js/src/constants/translations/en.json'),
        },
    fr: {
            ...require('/opt/app/hat/assets/js/apps/Iaso/domains/app/translations/fr.json'),
            ...require('/opt/app/node_modules/bluesquare-components/dist/locale/fr.json'),
            ...require('/opt/app/plugins/polio/js/src/constants/translations/fr.json'),
            ...require('/opt/app/plugins/registry/js/src/constants/translations/fr.json'),
        }
};

export default translations;
